var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-navbar',{attrs:{"type":"green","toggleable":""}},[_c('div',{staticClass:"container"},[_c('b-navbar-brand',[_c('img',{attrs:{"src":"img/header-title.svg","alt":""}})])],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4af4a020","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/QuizHeader.vue
// module id = 572
// module chunks = 0